<template>
  <b-modal :id="modalId"
           title="Delete Contact">
    <p>Are you sure you want to delete {{ channel.type | channelType }} contact {{ contact.name }}?</p>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click="hideModal">Cancel</button>
      <button type="button" class="mr-0 btn btn-danger"
              @click="promiseDeleteContact = handleDelete()"
              v-busy-button="promiseDeleteContact">Delete
      </button>
    </template>
  </b-modal>
</template>

<script>
  import contactService from '@/services/amio-api/contact.service'
  import notificationService from '@/services/notification/notification.service'

  export default {
    props: {
      modalId: {
        type: String,
        required: true
      },
      channel: {
        type: Object,
        required: true
      },
      contact: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        promiseDeleteContact: null
      }
    },

    methods: {
      hideModal() {
        this.promiseDeleteContact = null
        this.$root.$emit('bv::hide::modal', this.modalId)
      },

      handleDelete() {
        return contactService.delete(this.channel.id, this.contact.id)
          .then(() => {
            this.$emit('contactDeleted', this.contact)
            notificationService.success('Contact was successfully deleted')
          })
          .then(this.hideModal)
      }
    }
  }
</script>
